import { VolleyballGameLogType } from '../models/volleyball-game-log';
import { Locales } from './locales';

export const VolleyballGameLogTypeLocalization = {
  [Locales.ru]: {
    [VolleyballGameLogType.enter_game]: 'Выход на площадку',
    [VolleyballGameLogType.exit_game]: 'Уход с площадки',
    [VolleyballGameLogType.remove_game]: 'Удаление с площадки',
    [VolleyballGameLogType.serve_ace]: 'Эйс',
    [VolleyballGameLogType.serve_hit]: 'Подача',
    [VolleyballGameLogType.serve_fault]: 'Ошибка на подаче',
    [VolleyballGameLogType.good_serve]: 'Усложнённая подача',
    [VolleyballGameLogType.attack_spike]: 'Результативная атака',
    [VolleyballGameLogType.attack_shot]: 'Атака',
    [VolleyballGameLogType.attack_fault]: 'Ошибка атаки',
    [VolleyballGameLogType.stuff_block]: 'Результативный блок',
    [VolleyballGameLogType.block_rebound]: 'Блок',
    [VolleyballGameLogType.block_fault]: 'Ошибка на блоке',
    [VolleyballGameLogType.excellent_receive]: 'Отличный прием',
    [VolleyballGameLogType.receive]: 'Прием',
    [VolleyballGameLogType.receive_fault]: 'Ошибка на приеме',
    [VolleyballGameLogType.serve_receive]: 'Прием подачи',
    [VolleyballGameLogType.excellent_serve_receive]: 'Отличный прием подачи',
    [VolleyballGameLogType.serve_receive_fault]: 'Ошибка приема подачи',
    [VolleyballGameLogType.point]: 'Очко',
    [VolleyballGameLogType.fault]: 'Ошибка',
    [VolleyballGameLogType.timeout]: 'Таймаут',
    [VolleyballGameLogType.yellow_card]: 'Замечание: желтая карточка',
    [VolleyballGameLogType.tie_ball]: 'Спорный мяч',
  },
  [Locales.en]: {
    [VolleyballGameLogType.enter_game]: 'Entering the court',
    [VolleyballGameLogType.exit_game]: 'Exit the court',
    [VolleyballGameLogType.remove_game]: 'Removed from the court',
    [VolleyballGameLogType.serve_ace]: 'Ace',
    [VolleyballGameLogType.serve_hit]: 'Serve',
    [VolleyballGameLogType.serve_fault]: 'Mistake on a serve',
    [VolleyballGameLogType.good_serve]: 'Good serve',
    [VolleyballGameLogType.attack_spike]: 'Resulting attack',
    [VolleyballGameLogType.attack_shot]: 'Attack',
    [VolleyballGameLogType.attack_fault]: 'Attack fault',
    [VolleyballGameLogType.stuff_block]: 'Resulting block',
    [VolleyballGameLogType.block_rebound]: 'Block',
    [VolleyballGameLogType.block_fault]: 'Block fault',
    [VolleyballGameLogType.excellent_receive]: 'Excellent receive',
    [VolleyballGameLogType.receive]: 'Receive',
    [VolleyballGameLogType.receive_fault]: 'Receive fault',
    [VolleyballGameLogType.serve_receive]: 'Serve receive',
    [VolleyballGameLogType.excellent_serve_receive]: 'Excellent serve receive',
    [VolleyballGameLogType.serve_receive_fault]: 'Serve receive fault',
    [VolleyballGameLogType.point]: 'Point',
    [VolleyballGameLogType.fault]: 'Fault',
    [VolleyballGameLogType.timeout]: 'Timeout',
    [VolleyballGameLogType.yellow_card]: 'Yellow card',
    [VolleyballGameLogType.tie_ball]: 'Tie ball',
  }
};
